<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="alumno?en_incorporacion={{en_incorporacion}}&grupos_id={{grupos_id}}&carreras_planes_id={{carreras_planes_id}}&periodos_escolares_id={{periodos_escolares_id}}" titulo="Alumno / Control Escolar"></app-listar>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-hidden-mobile menu-izquierda is-2">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <app-tabla-opciones [ctrl]="ctrl" [filtro]="true"></app-tabla-opciones>

            <div id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 78.4vh;">
                <a id="catalogos" (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar'); ctrl.cargarCatalogo('carreras_planes', 'carrera-plan'); ctrl.cargarCatalogo('paises', 'paises'); ctrl.cargarCatalogo('estados', 'estados'); ctrl.cargarCatalogo('municipios', 'municipios'); ctrl.cargarCatalogo('articulos', 'servicio');"></a>
                <a id="recargar" (click)="ctrl.catalogoDependiente('estados', 'estados', ctrl.dato.get('paises_id').value); ctrl.catalogoDependiente('municipios', 'municipios', ctrl.dato.get('estados_id').value);"></a>
                <!-- <a id="municipios" (click)="ctrl.catalogoDependiente('municipios', 'municipios', ctrl.dato.controls.personas_rfcs.controls.estados_id.value,'localidades')"></a> -->

                <nav class="breadcrumb" *ngIf="filtro" aria-label="breadcrumbs">
                    <ul>
                        <li><a href="#">Grupo: </a></li>
                        <li class="is-active"><a href="#" aria-current="page">{{nombreGrupo}}</a></li>
                    </ul>
                </nav>

                <!--Tabla -->
                <table class="table is-striped is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando " style="overflow:auto;">
                    <thead>
                        <tr>
                            <th>
                                <abbr>Nombre</abbr>
                            </th>
                            <th>Matrícula</th>
                            <th>Sexo</th>
                            <!-- <th>CURP</th> -->
                            <th>Carrera</th>
                            <th>Grupo</th>
                            <th>Período escolar</th>
                            <th> </th>
                        </tr>
                    </thead>
                    <!-- FALTA MODALIDAD -->
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index" [ngClass]="{'blue-class': color[item.id]}">
                            <th style="vertical-align: middle;">{{ item.alumnos_metadatos.apellido_paterno }} {{ item.alumnos_metadatos.apellido_materno }} {{ item.alumnos_metadatos.nombre }}
                            </th>
                            <td style="vertical-align: middle;">{{ item.matricula }} </td>
                            <td style="vertical-align: middle;">{{ item.alumnos_metadatos.sexo }}</td>
                            <td style="vertical-align: middle;">{{ item.carreras_planes?.carrera }}</td>
                            <td style="vertical-align: middle;">{{ item.inscripciones.length ? item.inscripciones[0].grupos_inscripciones.clave+' / '+item.inscripciones[0].grupos_inscripciones.grupos_periodos_escolares.modalidades.nombre : '' }} </td>
                            <td style="vertical-align: middle;">{{ item.inscripciones.length ? item.inscripciones[0].grupos_inscripciones.grupos_periodos_escolares.fecha_inicio +' / '+ item.inscripciones[0].grupos_inscripciones.grupos_periodos_escolares.fecha_fin : '' }}</td>

                            <td style="vertical-align: middle;" class="has-text-centered">
                                <!-- acciones -->
                                <nav class="level" style="float:right">
                                    <app-tabla-acciones class="level-left" [item]="item" [index]="i" [ver]="true" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                </nav>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="8" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando">
          <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
            <article class="media">
              <div class="media-left">
                <figure class="image is-64x64">
                  <img [src]="item.foto ? ctrl.API_PATH+'/adjunto/personas/'+item.foto : item.avatar" alt="Image">
                </figure>
              </div>
              <div class="media-content">
                <div class="content" [ngClass]="{'blue-class': color[item.id]}">
                  <p>
                    <strong class="tag is-medium is-black">
                      {{ item.alumnos_metadatos.nombre }} {{ item.alumnos_metadatos.apellido_paterno }} {{ item.alumnos_metadatos.apellido_materno }}
                    </strong>
                    <strong class="tag is-medium is-primary">
                      <i class="fa fa-calendar pad-right-10"></i> {{ item.alumnos_metadatos.fecha_nacimiento }}
                    </strong>
                    <strong class="tag is-medium">
                      Sexo: {{ item.alumnos_metadatos.sexo }}
                    </strong>
                    <strong class="tag is-medium is-warning">
                      {{ item.alumnos_metadatos.curp }}
                    </strong>
                    <strong class="tag is-medium is-danger">
                      <i class="fa fa-envelope pad-right-10"></i> {{ item.alumnos_metadatos.email }}
                    </strong>
                  </p>

                </div>
                <nav class="level is-mobile" style="float:right">
                  <div class="level-left">
                    <!-- acciones -->
                    <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" [ver]="true" class="level-left"></app-tabla-acciones>
                  </div>
                </nav>
              </div>
            </article>
          </div>
        </span>
            </div>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>

        </div>
    </div>
</div>

<!-- MODAL FILTROS -->
<div class="modal" id="filtros">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 60%;">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="icon">
          <i class="fa fa-filter"></i>
        </span> Filtrar
            </p>
            <button type="button" class="delete" (click)="cancelarFiltros('filtros')"></button>
        </header>
        <section class="modal-card-body">

            <div class="columns">
                <div class="column is-6">
                    <!-- <label class="label">Carreras:</label> -->
                    <div class="control has-icons-left has-icons-right">
                        <div class="select">
                            <select class="select" [(ngModel)]="carreras_planes_id" (change)="grupo_carrera_plan()">
                          <option value="">Seleccione carrera plan</option>
                          <option *ngFor="let item of ctrl.carreras_planes" value="{{item.id}}">{{item.text}}</option>
                      </select>
                        </div>
                        <!-- <span class="icon is-small is-right" *ngIf="ctrl.dato.get('carreras_id').hasError('required') ">
                      <i class="fa fa-warning"></i>
                  </span>
                  <span class="help is-danger" *ngIf="ctrl.dato.get('carreras_id').hasError('required') ">Este campo es requerido.</span> -->
                    </div>
                </div>

                <div class="column is-6">
                    <!-- <label class="label">Carreras:</label> -->
                    <div class="control has-icons-left has-icons-right">
                        <div class="select">
                            <select class="select" [(ngModel)]="periodos_escolares_id" (change)="grupo_carrera_plan()">
                          <option value="">Seleccione periodo escolar</option>
                          <option *ngFor="let item of ctrl.periodos_escolares" value="{{item.id}}">{{ item.nombre  }} / {{item.modalidades?.nombre}} / {{ item.tipos_periodos?.nombre }}</option>
                      </select>
                        </div>
                        <!-- <span class="icon is-small is-right" *ngIf="ctrl.dato.get('carreras_id').hasError('required') ">
                      <i class="fa fa-warning"></i>
                  </span>
                  <span class="help is-danger" *ngIf="ctrl.dato.get('carreras_id').hasError('required') ">Este campo es requerido.</span> -->
                    </div>
                </div>
            </div>

            <div class="columns">
                <div class="column is-8">
                    <!-- <label class="label">Grupo</label> -->
                    <div class="control has-icons-left has-icons-right">
                        <div class="select">
                            <select class="select" [(ngModel)]="grupos_id">
                      <option value="">Seleccione un grupo</option>
                      <option *ngFor="let item of grupos" value="{{item.id}}">{{item.clave}} Nivel: {{item.nivel}}</option>
                  </select>
                        </div>
                        <!-- <span class="icon is-small is-right" *ngIf="ctrl.dato.get('grupos_id').hasError('required') ">
                  <i class="fa fa-warning"></i>
              </span>
              <span class="help is-danger" *ngIf="ctrl.dato.get('grupos_id').hasError('required') ">Este campo es requerido.</span> -->
                    </div>
                </div>
                <div class="column is-4">
                    <div class="b-checkbox is-info">
                        <input id="en_incorporacion" class="styled" [checked]="en_incorporacion == 1 ? true : false" (change)="en_incorporacion = en_incorporacion == 1 ? 0 : 1" type="checkbox">
                        <label for="en_incorporacion">
              En proceso de Incorporación
            </label>
                    </div>
                </div>
            </div>

        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="ctrl.listar(1); cancelarFiltros('filtros'); filtro=true; fNombreGrupo();">Aplicar filtros</a>
            <a class="button" (click)="cancelarFiltros('filtros'); filtro=false; grupos_id=''; carreras_planes_id=''; periodos_escolares_id=''; nombreGrupo = '';">Quitar filtros</a>
        </footer>
    </div>
</div>
<!-- MODAL FILTROS -->